import React, { useState } from 'react'
import { Message } from 'semantic-ui-react'

interface CopyInputProps {
  value: string
}

export default function CopyInput({ value }: CopyInputProps) {
  const [copied, setCopied] = useState(false)

  function handleCopy() {
    navigator.clipboard.writeText(value)
    setCopied(true)
  }

  return (
    <Message color="blue" className="flex items-center justify-between gap-2">
      <div className="truncate flex-1 text-black">{value}</div>
      <div className="cursor-pointer blue" onClick={handleCopy}>
        <i className={`${copied ? 'fas fa-check' : 'far fa-clone'} mr-1`} />
        {copied ? 'Copied' : 'Copy'}
      </div>
    </Message>
  )
}



// WEBPACK FOOTER //
// ./src/shared/components/CopyInput/index.tsx